import React from 'react'

import './Shlok.css'

export default function Shlok() {
  return (
    <>

      <div className='ShlokContentSection'>
        <h1 className='aboutShlok'>Bhagavad Geeta Quotes By Shri Krishna</h1>
      </div>
      <div className='shlokPara'>
        <p className='shlokParagraph'>
          1. Whenever dharma declines and the purpose of life is forgotten, I manifest myself on earth. I am born in every age to protect the good, to destroy evil, and to reestablish dharma.
        </p>
        <p className='shlokParagraph secShlokPara'>
          2. As they approach me, so I receive them. All paths, Arjuna, lead to me.
        </p>
        <p className='shlokParagraph secShlokPara'>
          3. I am the beginning, middle, and end of creation.
        </p>
        <p className='shlokParagraph secShlokPara'>
          4. Among animals I am the lion; among birds, the eagle Garuda. I am Prahlada, born among the demons, and of all that measures, I am time.
        </p>
        <p className='shlokParagraph secShlokPara'>
          5. I am death, which overcomes all, and the source of all beings still to be born.
        </p>
        <p className='shlokParagraph secShlokPara'>
          6. Just remember that I am, and that I support the entire cosmos with only a fragment of my being.
        </p>
        <p className='shlokParagraph secShlokPara'>
          7. Behold, Arjuna, a million divine forms, with an infinite variety of color and shape. Behold the gods of the natural world, and many more wonders never revealed before. Behold the entire cosmos turning within my body, and the other things you desire to see.
        </p>
        <p className='shlokParagraph secShlokPara'>
          8. I am time, the destroyer of all; I have come to consume the world.
        </p>
        <p className='shlokParagraph secShlokPara'>
          9. That one is dear to me who runs not after the pleasant or away from the painful, grieves not, lusts not, but lets things come and go as they happen.
        </p>
        <p className='shlokParagraph secShlokPara'>
          10. Just as a reservoir is of little use when the whole countryside is flooded, scriptures are of little use to the illumined man or woman, who sees the Lord everywhere.
        </p>
        <p className='shlokParagraph secShlokPara'>
          11. They alone see truly who see the Lord the same in every creature, who see the deathless in the hearts of all that die. Seeing the same Lord everywhere, they do not harm themselves or others. Thus they attain the supreme goal.
        </p>
        <p className='shlokParagraph secShlokPara'>
          12. With a drop of my energy I enter the earth and support all creatures. Through the moon, the vessel of life-giving fluid, I nourish all plants. I enter breathing creatures and dwell within as the life-giving breath. I am the fire in the stomach which digests all food.
        </p>
        <p className='shlokParagraph secShlokPara'>
          13. Those who worship the devas will go to the realm of the devas; those who worship their ancestors will be united with them after death. Those who worship phantoms will become phantoms; but my devotees will come to me. Those who worship the devas will go to the realm of the devas; those who worship their ancestors will be united with them after death. Those who worship phantoms will become phantoms; but my devotees will come to me.
        </p>
        <p className='shlokParagraph secShlokPara'>
          14. Fill your mind with me; love me; serve me; worship me always. Seeking me in your heart, you will at last be united with me.
        </p>
        <p className='shlokParagraph secShlokPara'>
          15. All the scriptures lead to me; I am their author and their wisdom.
        </p>
        <p className='shlokParagraph secShlokPara'>
          16. Bhishma, Drona, Jayadratha, Karna, and many others are already slain. Kill those whom I have killed. Do not hesitate. Fight in this battle and you will conquer your enemies.
        </p>
        <p className='shlokParagraph secShlokPara'>
          17. Not by knowledge of the Vedas, nor sacrifice, nor charity, nor rituals, nor even by severe asceticism has any other mortal seen what you have seen, O heroic Arjuna.
        </p>
        <p className='shlokParagraph secShlokPara'>
          18. Better indeed is knowledge than mechanical practice. Better than knowledge is meditation. But better still is surrender of attachment to results, because there follows immediate peace.
        </p>
        <p className='shlokParagraph secShlokPara'>
          19. Some realize the Self within them through the practice of meditation, some by the path of wisdom, and others by selfless service. Others may not know these paths; but hearing and following the instructions of an illumined teacher, they too go beyond death.
        </p>
        <p className='shlokParagraph secShlokPara'>
          20. The brightness of the sun, which lights up the world, the brightness of the moon and of fire - these are my glory.
        </p>
        <p className='shlokParagraph secShlokPara'>
          21. Calmness, gentleness, silence, self-restraint, and purity: these are the disciplines of the mind.97. To refrain from selfish acts is one kind of renunciation, called sannyasa; to renounce the fruit of action is another, called tyaga.
        </p>
        <p className='shlokParagraph secShlokPara'>
          22. By serving me with steadfast love, a man or woman goes beyond the gunas. Such a one is fit for union with Braman.
        </p>
        <p className='shlokParagraph secShlokPara'>
          23. When they see the variety of creation rooted in that unity and growing out of it, they attain fulfillment in Brahman.
        </p>
        <p className='shlokParagraph secShlokPara'>
          24. I have shared this profound truth with you, Arjuna. Those who understand it will attain wisdom; they will have done that which has to be done.
        </p>
        <p className='shlokParagraph secShlokPara'>
          25. I give you these precious words of wisdom; reflect on them and then do as you choose.
        </p>
      </div>

    </>
  )
}
